import { ProductBatchUpdateHistoryDoc } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';
import { observeProductBatchUpdateHistory } from 'src/utils/firebase/firebase-short-cut';

/**
 * 최근 5개의 상품 배치 업데이트 이력을 조회한다.
 * @param limit 조회할 이력 개수
 * @returns 최근 5개의 상품 배치 업데이트 이력
 */
const useProductBatchUpdateHistories = (limit = 5) => {
  const [productBatchUpdateHistories, setProductBatchUpdateHistories] = useState<ProductBatchUpdateHistoryDoc[]>([]);

  useEffect(() => {
    const productBatchUpdateHistory$ = observeProductBatchUpdateHistory([], {
      sortKey: 'timestamp',
      orderBy: 'desc',
      limit,
    });

    const subscription = productBatchUpdateHistory$.subscribe((productBatchUpdateHistories) => {
      setProductBatchUpdateHistories(productBatchUpdateHistories);
    });

    return () => subscription.unsubscribe();
  }, [limit]);

  return productBatchUpdateHistories;
};

export default useProductBatchUpdateHistories;
